import React from 'react';

const MatDashPanel = ({
  title,
  subtitle,
  icon: Icon,
  meta,
  headerAction,
  children,
  className = '',
  variant = 'light',
  bodyClassName = '',
  noBodyPadding = false,
}) => {
  const isPrimary = variant === 'primary';

  return (
    <section className={`md-card overflow-hidden mb-6 ${className}`.trim()}>
      {(title || subtitle || Icon || meta || headerAction) && (
        <div
          className={
            isPrimary
              ? 'bg-matdash-primary px-5 py-4'
              : 'px-5 py-4 border-b border-matdash-border bg-white'
          }
        >
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-start sm:items-center gap-3 min-w-0">
              {Icon && (
                <div
                  className={`md-icon-well shrink-0 ${
                    isPrimary
                      ? 'bg-white text-matdash-primary'
                      : 'bg-matdash-primary-subtle text-matdash-primary'
                  }`}
                >
                  <Icon className="h-5 w-5" />
                </div>
              )}
              <div className="min-w-0">
                {title && (
                  <h2
                    className={`text-base sm:text-lg font-semibold mb-0 truncate ${
                      isPrimary ? 'text-white' : 'text-matdash-dark'
                    }`}
                  >
                    {title}
                  </h2>
                )}
                {subtitle && (
                  <p
                    className={`text-xs sm:text-sm mt-0.5 mb-0 ${
                      isPrimary ? 'text-white/80' : 'md-card-subtitle'
                    }`}
                  >
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
            {(meta || headerAction) && (
              <div className="flex flex-wrap items-center gap-2 sm:gap-3 shrink-0">
                {meta}
                {headerAction}
              </div>
            )}
          </div>
        </div>
      )}
      <div className={noBodyPadding ? bodyClassName : `md-card-body ${bodyClassName}`.trim()}>
        {children}
      </div>
    </section>
  );
};

export default MatDashPanel;
